<div class="aem-Grid aem-Grid--12 aem-Grid--default--12">
    <div class="responsivegrid aem-GridColumn aem-GridColumn--default--12">
        <div class="aem-Grid aem-Grid--12 aem-Grid--default--12">
            <div class="experiencefragment aem-GridColumn aem-GridColumn--default--12">
                <div class="column-control aem-GridColumn aem-GridColumn--default--12">
                    <div class="column-control-wrapper ">
                        <div class="row col-md-auto">
                            <div class="container-fluid">
                                <div class="row abs-no-gutters">
                                    <div id="slim-padding" class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                        <div class="experiencefragment section">
                                            <div [innerHTML]="frequentlyAskedQuestion | safeHtml"></div>
                                        </div>
                                    </div>
                                    <div class="faq-btn-ml mt-5 mr-5">
                                        <span>
                                            <button (click)="openManageFreshpass()"
                                                    class="btn btn-primary btn-block body-m--extra-bold">
                                                Continue FreshPass Subscription
                                            </button>
                                        </span>
                                    </div>
                                    <div class="mt-5">
                                        <span>
                                            <button (click)="openHomepage()"
                                                    class="btn btn-primary btn-block body-m--extra-bold ">
                                            No Thanks. Continue Shopping
                                        </button>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
